import { OwlOptions } from "ngx-owl-carousel-o";
import { Component, OnInit, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CoreService } from "../../core.service";
import { BaseComponent } from '@web/base/shared/components/base/base.component';

@Component({
  selector: "web-banners-header",
  templateUrl: "./banners-header.component.html",
  styleUrls: ["./banners-header.component.scss"]
})
export class BannersHeaderComponent extends BaseComponent implements OnInit {
  @Input() banners;

  bannerOptions: OwlOptions;

  constructor(translate: TranslateService, private coreService: CoreService) {
    super(translate);
  }

  ngOnInit() {

    this.bannerOptions = {
      loop: true,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      dots: false,
      nav: true,
      navText: ['&#10094;', '&#10095;'],
      navSpeed: 700,
      center: true,
      autoplay: true,
      items: 1,
      autoWidth: true,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        }
      }
    };
  }

  // shuffle(banners) {
  //   let i = banners.length;
  //   while (i--) {
  //     const ri = Math.floor(Math.random() * (i + 1));
  //     [banners[i], banners[ri]] = [banners[ri], banners[i]];
  //   }
  //   return banners;
  // }
}
